<script setup>
import Origins from '@/components/sections/origins/origins';
import { ref, onMounted} from 'vue';
import {useMainStore} from '@/stores/main';
import Introduction from '@/components/sections/Introduction/Introduction.vue';
import Effect from '@/components/sections/Effect/Effect.vue';
import Pollutants from '@/components/sections/Pollutants/Pollutants.vue';
import Sources from '@/components/sections/sources/sources.vue';
import Benefits from '@/components/sections/Benefits/Benefits.vue';
import Navigation from '@/components/Navigation.vue';
import Actions from '@/components/sections/Actions/Actions.vue';
// import Sources from '@/components/sections/sources/sources.vue';

const store = useMainStore();

const container = ref(null);


const measure = () => {
    store.width = container.value.clientWidth;
    store.measured = true;
};

onMounted(() => {
    measure();
});
</script>


<template>
    <div class="App">
        <header>
            <img src="logo_en.gif" alt="Logo European Commission" />
            <h1>
                European commission<br>
                Environment
            </h1>
        </header>
        <main>
            <div
                ref="container"
                class="container">
                <template v-if="store.measured">
                    <Introduction />
                    <Pollutants />
                    <Sources />
                    <Effect />
                    <Origins />
                    <Actions />
                    <Benefits />
                </template>
            </div>
        </main>

        <Navigation />
    </div>


</template>


<style lang="scss">
@import '@/styles/index.scss';
@import '@/styles/variables.scss';

.App {
    position: relative;
    width: 986px;
    max-width: 100%;
    margin: 0 auto;
    font-family: Lato, sans-serif;
}

header {
    display: flex;
    align-items: flex-end;
    gap: 36px;
    padding: 24px 0;
    border-bottom: 3px solid #074A8B;

    h1 {
        font-size: 24px;
        font-weight: 700;
        color: var(--blue);
        margin: 0;
    }
}

main {
    .container {
        background: #D7DADC;
    }
}

* {
    box-sizing: border-box;
}


:root {
    --grey-1: #ddd;
    --green: #4F9988;
    --blue: #004A7A;
    --pink: #FFCEDA;
    --standard-padding: 12px;
}

.ml-color-0 {
    fill: #31B7AF;
}

.ml-color-1 {
    fill: #CEB70F;
}

.ml-color-2 {
    fill: #BD9BC5;
}

.ml-color-3 {
    fill: #FF7164;
}

.ml-color-4 {
    fill: #D51067;
}

.ml-color-5 {
    fill: #004A7A;
}

.ml-color-6 {
    fill: #31B7AF;
}

.ml-color-7 {
    fill: #00B9ED;
}
</style>
